import { apiClient } from '@/lib/apiClient';

export type VoiceProvider = 'telnyx' | 'twilio';

export interface VoiceProviderResponse {
  provider: VoiceProvider;
  user_id: number;
}

export interface VoiceProviderUpdateResponse {
  provider: VoiceProvider;
  user_id: number;
  updated: boolean;
}

export const getVoiceProvider = async (): Promise<VoiceProviderResponse> => {
  return apiClient.get<VoiceProviderResponse>('/voice/provider');
};

export const setVoiceProvider = async (
  provider: VoiceProvider
): Promise<VoiceProviderUpdateResponse> => {
  return apiClient.patch<VoiceProviderUpdateResponse>('/voice/provider', { provider });
};
